import React, { createContext, useMemo } from 'react';
import { envVariables } from '@fabric-ui/utils';
import { GraphQLClient } from 'graphql-request';
import { ErrorTypes } from '../types/query.types';
import { isClientError, isGenericError, isGraphQLResponse } from '../utils/graphqlUtils';

interface GraphQLClientContextProps {
  client: GraphQLClient;
}

export const GraphQLClientContext = createContext<GraphQLClientContextProps>({} as GraphQLClientContextProps);

export const GraphQLClientProvider = ({ children }: { children: React.ReactNode }) => {
  const client = new GraphQLClient(`${envVariables.VITE_API_URL}/graphql`, {
    method: 'POST',
    responseMiddleware: response => {
      const graphqlErrors = (isGraphQLResponse(response) ? response.errors : isClientError(response) ? response.response.errors : []) ?? [];

      if (graphqlErrors.length > 0) {
        graphqlErrors.forEach(({ message, locations, path }) =>
          console.warn(`[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`)
        );
        return;
      }

      if (
        (isClientError(response) || isGenericError(response)) &&
        !['signal is aborted without reason', 'The operation was aborted.'].includes(response.message.trim())
      ) {
        console.warn(`${isClientError(response) ? ErrorTypes.Network : ErrorTypes.Generic}: ${response}`);
      }
    },
  });

  const value = useMemo(() => ({ client }), [client]);
  return <GraphQLClientContext value={value}>{children}</GraphQLClientContext>;
};
